// extracted by mini-css-extract-plugin
export default {"question":"Style_question__NT24n","onTopBtn":"Style_onTopBtn__vxPHF"};